<template>
  <div>
  <meta name="viewport" content="width=device-width,initial-scale=1.0">
    <div class="bmdiv mat tc6">
      <div class="tdiv bgw pb20">
        <div class="fs30 nm bg-red twhite fbold tcenter">丽水技师学院报名查询</div>
        <div class="txt pl35 pr35" v-if="flow==1">
          <div class="fs15 mb25">
            <div class="mt20 mb5">尊敬的家长朋友、同学们：</div>
            <div class="tdent lh17">丽水技师学院2021年秋季入学招生工作已开始，现开设线上招生报名登记，请填写身份证号查询报名详情：</div>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">身份证号</label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写身份证号" v-model="cid">
          </div>
          <div class="btndiv tcenter">
            <a href="javascript:;" class="zbtn bg-red twhite fs15 br2" @click="getCardInfo">立即查询</a>
          </div>
        </div>
        <div class="xt pl35 pr35" v-else-if="flow == 2"><!-- 补充信息，得看看是否已经开启信息补充 -->
          <div class="fs15 mb25">
            <div class="mt20 mb5">尊敬的{{info.name}}：</div>
            <div class="tdent lh17">丽水技师学院2021年秋季入学招生工作已开始，现开设线上招生报名登记，请填写以下信息进行补充：</div>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">状态</label>
            <label for="" class="dblock fs16 mb5" style="padding-left: 20px;">信息待补充</label>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">姓名</label>
            <label for="" class="dblock fs16 mb5" style="padding-left: 20px;">{{info.name}}</label>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">身份证号</label>
            <label for="" class="dblock fs16 mb5" style="padding-left: 20px;">{{info.id_card}}</label>
          </div>
          <div class="inputdiv" v-if="info.major">
            <label for="" class="dblock fs16 mb5">录取专业</label>
            <label for="" class="dblock fs16 mb5" style="padding-left: 20px;">{{info.major}}</label>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">准考证号<font color="red">*</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="准考证号（必填）" v-model="info.admission_number">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">身高（cm）<font color="red">*</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="身高（必填）" v-model="info.height">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">体重（kg）<font color="red">*</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="体重（必填）" v-model="info.weight">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">鞋码<font color="red">*</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="鞋码（必填）" v-model="info.shoes_size">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">接收录取通知书地址<font color="red">*</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="接收录取通知书地址（必填）" v-model="info.mailing_address">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">成绩（含体育总分）<font color="red">*</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="成绩（必填）" v-model="info.score">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">成绩截图<font color="red">*</font></label>
            <input ref="fileAchievement" type="file" @change="getAchievementFiles($event)" accept="image/*" />
            <input type="text" class="input border-dd bg-f4 br2 wd80" disabled :value="(fileAchievement!='')?fileAchievement:info.score_picture"/>
            <a class="zbtn bg-red twhite fs15 br2" style="width: 15%;padding: 5px 0;vertical-align: top;" href="javascript:;" @click="changeAchievement">上传</a>
          </div>
          <div class="btndiv tcenter">
            <a href="javascript:;" class="zbtn bg-red twhite fs15 br2" v-if="info.before_test == 1">补充信息未开始</a>
            <a href="javascript:;" class="zbtn bg-red twhite fs15 br2" @click="subInfo" v-else>提交</a>
          </div>
        </div>
        <div class="xt pl35 pr35" v-else-if="flow == 3"><!-- 成功被录取，显示录取信息并可以点击下一步线上支付或者到现场缴费 -->
          <div class="fs15 mb25">
            <div class="mt20 mb5">尊敬的{{info.name}}：</div>
            <div class="tdent lh17">丽水技师学院2021年秋季入学招生工作已开始，现开设线上招生报名登记，以下是您的录取信息：</div>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">状态</label>
            <label for="" class="dblock fs16 mb5" style="padding-left: 20px;" v-if="info.finance_check == 1">已录取，已支付,已审核</label>
            <label for="" class="dblock fs16 mb5" style="padding-left: 20px;" v-else-if="info.pay_status == 1">已录取，已支付,未审核</label>
            <label for="" class="dblock fs16 mb5" style="padding-left: 20px;" v-else>已录取，未支付</label>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">姓名</label>
            <label for="" class="dblock fs16 mb5" style="padding-left: 20px;">{{info.name}}</label>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">身份证号</label>
            <label for="" class="dblock fs16 mb5" style="padding-left: 20px;">{{info.id_card}}</label>
          </div>
          <div class="inputdiv" v-if="info.major">
            <label for="" class="dblock fs16 mb5">录取专业</label>
            <label for="" class="dblock fs16 mb5" style="padding-left: 20px;">{{info.major}}</label>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">支付金额</label>
            <label for="" class="dblock fs16 mb5" style="padding-left: 20px;">{{info.pay_money}}</label>
          </div>

          <div class="btndiv tcenter">
            <a href="javascript:;" class="zbtn bg-red twhite fs15 br2" v-if="(info.finance_check == 1)" @click="goAdmission">查看录取通知书</a>
            <a href="javascript:;" class="zbtn bg-red twhite fs15 br2" v-else-if="(info.pay_status == 1)">已支付，等待审核</a>
            <a href="javascript:;" class="zbtn bg-red twhite fs15 br2" v-else-if="info.before_test == 1">支付未开启</a>
            <a href="javascript:;" class="zbtn bg-red twhite fs15 br2" @click="subPay" v-else>立即支付</a>
          </div>
        </div>
        <div class="xt pl35 pr35" v-else-if="flow == 4"><!-- 成功被录取，显示录取信息并可以点击下一步线上支付或者到现场缴费 -->
          <div class="fs15 mb25">
            <div class="mt20 mb5">尊敬的{{info.name}}：</div>
            <div class="tdent lh17">丽水技师学院2021年秋季入学招生工作已开始，现开设线上招生报名登记，以下是您的录取信息：</div>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">状态</label>
            <label for="" class="dblock fs16 mb5" style="padding-left: 20px;" v-if="info.enroll_status == $const.ENROLL_STATUS_2">未被录取</label>
            <label for="" class="dblock fs16 mb5" style="padding-left: 20px;" v-else-if="info.enroll_status == $const.ENROLL_STATUS_3">等待面试</label>
            <label for="" class="dblock fs16 mb5" style="padding-left: 20px;" v-else-if="info.enroll_status == $const.ENROLL_STATUS_4">补录</label>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">姓名</label>
            <label for="" class="dblock fs16 mb5" style="padding-left: 20px;">{{info.name}}</label>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">身份证号</label>
            <label for="" class="dblock fs16 mb5" style="padding-left: 20px;">{{info.id_card}}</label>
          </div>
          <div class="inputdiv" v-if="info.major">
            <label for="" class="dblock fs16 mb5">录取专业</label>
            <label for="" class="dblock fs16 mb5" style="padding-left: 20px;">{{info.major}}</label>
          </div>
        </div>
        <div class="message" v-else-if="flow == 5"><!-- 点击了线上支付 -->
          <div class="msg1">您成功被录取<span>{{info.major}}</span>专业</div>
           <div class="nt">苹果手机请保存二维码，使用微信或支付宝打开图片。如需详细了解，请致电丽水技师学院招生办：0578-2306000、2306111、2306222</div>
          <div class="msg2">请您在<span>{{expired_date}}以前</span>完成支付，否则报名会自动取消</div>
          <div class="msg_img"><img :src="payImg"/></div>
          <div class="msg3">待支付款项：<span>{{info.pay_money}}</span>元</div>
        </div>
        <div class="success" v-else-if="flow == 6"><!-- 支付成功，等待后台审核 -->
          <div class="suc1">
            <img src="../assets/images/success.jpg"/>
          </div>
          <div class="suc2">支付成功</div>
          <div class="suc3">你已完成支付</div>
          <div class="suc4"><router-link to="/">返回首页</router-link></div>
        </div>
      </div>
      <div class="bdiv bgw mt10 fs15 tc9 tcenter pt10 pb10">
        <div class="fbold">丽水技师学院</div>
        <div>Copyright&nbsp;&copy;&nbsp;2021 丽水技师学院</div>
      </div>
<!--        <img :src="payImg" style="width: 200px;height: 200px;display: block;position:fixed;top:50%;left: 50%;margin-top: -100px;margin-left: -100px;"/>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "sign",
  data(){
    return {
      info:{
        id:'',//报名id
        name:'',
        id_card:'',
        major:'',//录取专业
        finance_check:'',//财务教研
        admission_number:'',//准考证号
        height:'',//身高
        weight:'',//体重
        shoes_size:'',//鞋码
        score:'',//成绩
        score_picture:'',//成绩截图
        mailing_address:'',//邮寄地址
        pay_money:'',
        enroll_status:'',//录取状态
        pay_status:'',//支付状态
        before_test:1,
      },
      flow:1,
      payImg:'',
      cid:'',
      achievementFiles:[],
      fileAchievement:'',
      expired_date:'',
    }
  },
  created() {
    this.cid = this.$route.query.cid;
  },
  mounted: function() {
    document.getElementsByTagName("body")[0].className="bm_body";
  },
  methods:{
    goAdmission:function(){
      let routeUrl = this.$router.resolve({
        path: "/admission",
        query: {id_card:this.info.id_card}
      });
      window.open(routeUrl.href, '_blank');
    },
    subInfo:function(){
      if(!this.info.score_picture && !this.fileAchievement){
        alert('成绩截图未上传');return false;
      }
      let param = new FormData();
      if(this.achievementFiles.length > 0){
        this.info.score_picture = this.fileAchievement;
        param.append('score_picture',this.achievementFiles[0],this.achievementFiles[0].name);
      }
      for(let key in this.info){
        param.append(key,this.info[key]);
      }
      let config = {
        headers:{'Content-Type':'multipart/form-data'}
      };
      this.$request.postFile('supplementary-info',param,config,response => {
        if(response.status == 200 && response.data.code == 200){
          //报名成功
          alert('报名成功,等待审核');
          this.flow = 1;
        }else{
          alert(response.data.message);
        }
      },error => {
        console.log(error);
      })
    },
    getAchievementFiles:function(e){
      this.achievementFiles = e.target.files
      this.fileAchievement = '';
      for (let i=0; i < e.target.files.length;i++){
        this.fileAchievement += e.target.files[i]['name']+';'
      }
    },
    changeAchievement:function(){
      this.$refs.fileAchievement.dispatchEvent(new MouseEvent('click'))
    },
    getCardInfo(){
      var getParam = {}
      getParam['id_card'] = this.cid
      this.$request.get('enroll-detail',getParam,(response)=>{
        if(response.data.code == 200){
          for(var ind in this.info){
            this.info[ind] = response.data.data[ind];
          }
          if(response.data.data.enroll_status == this.$const.ENROLL_STATUS_0){
            this.flow = 2;
          }else if(response.data.data.enroll_status == this.$const.ENROLL_STATUS_1){
            this.flow = 3;
          }else if(response.data.data.enroll_status == this.$const.ENROLL_STATUS_2 || response.data.data.enroll_status == this.$const.ENROLL_STATUS_4 || response.data.data.enroll_status == this.$const.ENROLL_STATUS_3){
            this.flow = 4;
          }
        }else{
          alert(response.data.message);
        }
      })
    },
    subPay(){
      //调取支付接口
      var getParam = {}
      getParam['id'] = this.info.id
      this.$request.post('enroll-pay',getParam,(response)=>{
        if(response.data.code == 200){
          this.payImg = response.data.data.src
          this.expired_date = response.data.data.expired_date
          this.flow = 5
          //开启定时任务 查看订单状态
          clearInterval(timer);
          var timer = setInterval(()=>{
            var getParam1 = {}
            getParam1['order_no'] = response.data.data.order_no
            this.$request.get('pay-detail',getParam1,(response)=>{
              if(response.data.code == 200){
                if(response.data.data.pay_status == 1){
                  clearInterval(timer);
                  this.flow = 6
                }
                if(response.data.data.expired == 1){
                  clearInterval(timer);
                  this.flow = 3
                  alert('支付已过期')
                }
              }
              else if(response.data.code == 250){
                clearInterval(timer);
                alert(response.data.message)
                this.flow = 1
              }
            });
          },3000);
        }else{
          alert('服务器错误，请重试');
          this.flow = 3;
        }
      },(response)=>{
        alert('服务器错误，请重试');
        this.flow = 1;
      })
    },
  },
  watch:{
  }
}
</script>

<style scoped>
  .bmdiv{width: 95%;max-width: 430px;}
  .bmdiv .nm{height: 100px;line-height: 100px;font-size: 200%;}
  .bmdiv .inputdiv{margin-bottom: 20px;}
  .bmdiv .inputdiv input[type=file]{display: none;}
  .bmdiv input,.bmdiv select{line-height: 32px;height: 32px;}
  .bmdiv .wd100{width: 100%;}
  .bmdiv .wd80{width: 80%;}
  .bmdiv .txt{padding: 0 6%;min-height: 550px;}
  .bmdiv .tdent{text-align: justify;}
  .bmdiv .between{justify-content: space-between;}
  .bmdiv .input:focus{background-color: #fff;border: 1px solid #94070a;box-shadow: 0 0 8px #94070a;}
  .bmdiv textarea{width: 570px;height: 300px;resize: vertical;}
  .bmdiv .zbtn{padding: 7px 45px;width: 80%;}
  .message{height: 600px;}
  .message .msg1{font-size: 20px;padding-left: 20px;padding-right: 20px;margin-top: 110px;text-align: center;}
  .message .msg1 span{font-size: 24px;color: #000;}
  .message .msg2{font-size: 14px;padding-left: 50px;padding-right: 50px;margin-top: 20px;}
  .message .msg2 span{color: red;}
  .message .msg_img{margin-top: 40px;width: 100%}
  .message .msg_img img{width: 200px;height: 200px;display: block;margin: 0 auto;}
  .message .msg3{text-align: center;margin-top: 40px;font-size: 20px;}
  .message .msg3 span{color:red;}
  .success {text-align: center;}
  .suc1{margin-top: 170px;}
  .suc2{font-size: 26px;color: #000;font-weight: bold;margin-top: 20px;}
  .suc3{line-height: 24px;}
  .suc4{margin-top: 60px;}
  .suc4 a{margin:0 auto;display:block;line-height:48px;background: #fff;border: 2px solid #979797;color: #2b2b2b;width: 154px;height: 52px;border-radius: 8px;font-size: 18px;margin-bottom: 150px;}
  .nt{padding: 10px 30px;line-height: 1.6;text-align: justify;font-size: 15px;}
</style>
<style>
.bm_body{min-width: auto;background: #f2f2f2;}
</style>



// WEBPACK FOOTER //
// src/pages/signSearch.vue